import { cn } from "@/lib/utils";

interface TabButtonProps {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

export const TabButton = (props: Readonly<TabButtonProps>) => {
  const { isActive, onClick, children } = props;

  return (
    <button
      onClick={onClick}
      className={cn(
        "flex items-center justify-center gap-2 w-[160px] h-10 px-3 rounded-[5px] font-bold text-sm transition-colors ",
        isActive
          ? "bg-[#6888e1] text-white fill-white"
          : "bg-white text-[#6888e1] fill-[#6888e1] hover:bg-gray-50 hover:cursor-pointer",
      )}
    >
      {children}
    </button>
  );
};
